module.exports = __webpack_public_path__ + "static/media/CELULOSA.5765b669.png";